import axios from 'axios'
import socketIO from 'socket.io-client'

export { default as Posts } from './posts.js'

let getBaseURL = () => {
  // if (process.env.NODE_ENV === 'development') {
  //   return `http://anydata.wonglok.com`
  // } else {
  //   return `https://lok.anydata.io`
  // }
  return `https://pl.anydata.io`
}

export const getSocketIO = ({ namespace = 'test' }) => {
  let baseURL = getBaseURL()
  let sock = socketIO(`${baseURL}/${namespace}`)
  return sock
}

export const testSocket = getSocketIO({ namespace: 'omg' })
testSocket.emit('omg', { frontEnd: 1 })
testSocket.on('omg', (data) => {
  console.log(data)
})

// export const testSocket = getSocketIO({ namespace: 'test' })
// export const chatSocket = getSocketIO({ namespace: 'chat' })

const netDefaults = {
  // blob / json
  responseType: 'json',
  onUploadProgress: () => {},
  onDownloadProgress: () => {}
}

export const getNet = ({
  responseType,
  onUploadProgress = () => {},
  onDownloadProgress = () => {}
} = netDefaults) => {
  let baseURL = getBaseURL()

  return axios.create({
    baseURL,
    responseType,
    withCredentials: true,
    // timeout: 1000,
    onDownloadProgress: onDownloadProgress,
    onUploadProgress: onUploadProgress,
    headers: {
      // 'X-JWT-Token': ''
    }
  })
}

export const xjs = window.xjs

/* --------------- AUTH ---------------- */
export const checkUniqueUsername = async ({ username }) => {
  let resp = await getNet().post(`/auth/check-unique-username`, {
    username: username.toLowerCase()
  })

  console.log('checkUniqueUsername', resp.data.data)
  return resp.data.data
}

export const register = async ({ username, password }) => {
  let resp = await getNet().post(`/auth/register`, {
    username: username.toLowerCase(),
    password
  })

  console.log('register', resp.data.data)
  return resp.data.data
}

export const login = async ({ username, password }) => {
  let resp = await getNet().post(`/auth/login`, {
    username: username.toLowerCase(),
    password
  })

  console.log('login', resp.data.data)
  return resp.data.data
}

export const getProfile = async ({ token }) => {
  let resp = await getNet().post(`/auth/profile`, {
    token
  })

  console.log('getProfile', resp.data.data)
  return resp.data.data
}
/* ------------------------------- */

export const lookUp = async ({ word }) => {
  let resp = await getNet().get(`/wordnet/${word}`)

  console.log('login', resp.data.data)
  return resp.data.data
}

/* ------------------------------- */
export const loginSlots = {}

let NSRemeber = 'rememberMe_' + getBaseURL()
export const rememberMe = ({ profile }) => {
  profile.lastLoginDate = (new Date()).getTime()
  let user = profile.user
  loginSlots[user.username] = profile
  localStorage.setItem(NSRemeber, JSON.stringify(loginSlots))
  syncState()
}

export const forgetMe = ({ profile }) => {
  let user = profile.user
  delete loginSlots[user.username]
  localStorage.setItem(NSRemeber, JSON.stringify(loginSlots))
  syncState()
}

export const hydrate = () => {
  let restore = localStorage.getItem(NSRemeber)
  if (restore && (restore !== null || restore !== 'null')) {
    restore = JSON.parse(restore)
    for (var kn in restore) {
      loginSlots[kn] = restore[kn]
    }
  }
  syncState()
}

export const getLoggedInList = () => {
  let arr = []
  for (var kn in loginSlots) {
    arr.push(loginSlots[kn])
  }
  arr = arr.sort((a, b) => {
    if (a.lastLoginDate > b.lastLoginDate) {
      return -1
    } else if (a.lastLoginDate < b.lastLoginDate) {
      return 1
    } else {
      return 0
    }
  })
  return arr
}

export const getCurrentUser = () => {
  let list = getLoggedInList()
  if (list.length > 0) {
    return list[0]
  } else {
    return false
  }
}

export const changeProfile = ({ profile }) => {
  profile.lastLoginDate = (new Date()).getTime()
  let user = profile.user
  loginSlots[user.username] = {
    ...profile
  }
  syncState()
}

export const state = {
  users: false,
  me: false
}

export const syncState = () => {
  state.users = getLoggedInList()
  state.me = getCurrentUser()
}
hydrate()

export const saveScroll = () => {
  window.sessionStorage.setItem('@scroll@' + window.location.href, window.scrollY)
}

export const restoreScroll = () => {
  let num = Number(sessionStorage.getItem('@scroll@' + window.location.href)) || 0
  window.scrollTo(0, num)
}

window.addEventListener('restore-scroll', () => {
  restoreScroll()
  setTimeout(() => {
    restoreScroll()
  }, 10)
}, { passive: false })

window.addEventListener('scroll', () => {
  saveScroll()
}, { passive: false })
